import React from "react";
import "../.csscode/modal.css";

export default function GenericModal({ open, title, message, onSelect, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p style={{ marginBottom: "16px" }}>{message}</p>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "12px" }}>
            <button
              className="btn btn-primary"
              onClick={() => onSelect("with")}
            >
              With Questions
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => onSelect("without")}
            >
              Without Questions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
